import CookieConsent from "react-cookie-consent";

import React from "react";
import { IStyles } from "components/common/$styles";

export const CookieBanner: React.FC<IStyles> = (): React.ReactElement => {
  return (
    <CookieConsent
      location="bottom"
      cookieName="cookiesTrack"
      containerClasses="cookie-banner"
      buttonClasses="cookie-banner-button"
      buttonWrapperClasses="cookie-banner-button-wrapper"
      buttonText="Accept"
    >
      By clicking «Accept», you agree to the storing of cookies on your device to enhance site
      navigation, analyze site usage, and assist in our marketing efforts.
    </CookieConsent>
  );
};
